import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();

  // Navigate to the Login Page when the button is clicked
  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <h1 className="school-name">The Oxford Convent English Medium School, Kajuri</h1>
        <p className="welcome-message">Welcome to the Fee Management System</p>
        <button className="login-button" onClick={handleLogin}>Login</button>
      </div>
    </div>
  );
};

export default WelcomePage;
